export const comments_5089934 = {"data":{"data":[],"links":{}}}